export const GOOGLE_MAPS_API_VERSION = "3.64";
